import {AsiDialogView} from "@asi-ngtools/lib";
import {Component} from "@angular/core";
import {FormationDto} from "@common/resources/resources";


@Component({
  selector: 'modal',
  templateUrl: './modal.component.html'
})
export class ModalDialog extends AsiDialogView {

  formations: Array<FormationDto>;

  constructor() {
    super();
  }

  close() {
    this.dialog.close();
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/common/utils/dialog/modal/modal.component.ts